/*
I used an untypeform..but maybe could have used a typed form.
This is generally called via a router action where an Id is passed in the url.
but can also be embedded in a component (ie. dashboard), where the record is set via input, and closing is done via events.

note: for now, we do the passing of records from dashboard only to speed it up and because the situation is read-only.
In other situations, we consider the underlying data could be being updated by another user.

*/

import { formatDate, Location, ViewportScroller } from "@angular/common";
import {
    OnInit,
    Component,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
    ViewChild, ElementRef,
    Input,
    SimpleChanges,
    OnChanges,
    Output,
    EventEmitter,
} from "@angular/core";
import { OverlayContainer } from "@angular/cdk/overlay";
import { ActivatedRoute, Router } from "@angular/router";
import { BrowserUtils } from "@azure/msal-browser";

import { MatPaginator } from "@angular/material/paginator";
import { MatTableExporterDirective } from "mat-table-exporter";
import { WorkRequestService } from "@app-services/work-request.service";
import {
    Milestone,
    Resource,
    WorkRequest,
    WorkRequestAuditView,

} from "@app-models/work-request";
import { FormControl, UntypedFormBuilder } from "@angular/forms";
import { DatePipe } from "@angular/common";
import {
    getCurrentUserFromStorage,    
    getPreviousViewFromStorage,
    getScreenModeFromStorage,
} from "@app/utils/storage-utils";
import { AzureUser } from "@app-models/azure-user";
import { AlertService } from "@app/modules/alert";
import { GlobalConstants } from "@app/utils/global-constants";
import { GlobalService } from "@app-services/global.services";

import { NgxSpinnerService } from "ngx-spinner";
import { GraphService } from "@app/services/graph.service";
import { WorkRequestBase } from "./work-request-base";

import {jsPDF} from 'jspdf';
import { UtcConverterService, UtcToLocalTimeFormat } from "@app/services/utc-converter.service";

@Component({
    selector: "app-work-request-status",
    templateUrl: "./work-request-status.component.html",
    styleUrls: ["./work-request-status.component.scss"],
    changeDetection: ChangeDetectionStrategy.Default
})
export class WorkRequestStatusComponent extends WorkRequestBase implements OnInit, OnChanges {
    @Input() inputWorkRequest: WorkRequest;    
    @Output() closingCompoment: EventEmitter<boolean> = new EventEmitter();
    
    //------------------------------------------
    // Constants
    //------------------------------------------
    infoMesageOptions = {
        autoClose: true,
        keepAfterRouteChange: false,
    };
    errorMesageOptions = {
        autoClose: false,
        keepAfterRouteChange: true,
    };

    saveMesageOptions = {
        autoClose: true,        
        keepAfterRouteChange: true,
    };

    errorMessage = "message";
    msg = {
        isClosed: "This work request has been closed and cannot be changed",
        isSubmitted: "This work request has been submitted and cannot be changed by the initiator.",
        isNotSubmitted:
            "This work request has NOT been submitted by the user. It cannot be changed.",
        isNotApproved: "This timesheet has NOT been approved by the manager.",

        saved: "The work request has been saved.",
        deleted: "The work request has been deleted.",
        submitted: "The work request has been submitted to Enterprise Technology.",
        internalReview: "The work request has been set to internal review.",
        inProgress: "The work request has been set to in-progress.",
        closed: "The work request has been set to closed.",

        entryNotFound: "The project was not found.",
        auditLogRetrievalError: "The Audit log could not be retreived.",
        screenTitle: "should I have something here?"

  
    };
    DATE_FORMAT = "yyyy-MM-dd";
    DATE_TIME_FORMAT = "yyyy-MM-dd h:mm:ss a";

    QUESTION_NO = "No";
    QUESTION_YES = "Yes";
    yesNoOptions = [this.QUESTION_NO,this.QUESTION_YES];
    quillEditorModules = {}
    href = "";

    ADMIN_MODE = GlobalConstants.REQUEST_FORM_MODE_ADMIN;
    USER_MODE = GlobalConstants.REQUEST_FORM_MODE_USER;
    PM_MODE = GlobalConstants.REQUEST_FORM_MODE_PM;


    //------------------------------------------
    //
    //------------------------------------------
    
    workRequest: WorkRequest = { projectStatus : ""};
    retrievedWorkRequest: WorkRequest = {};
    projectManager = "";
    projectHeader: string;
    
    formError = "";
    auditDateCtrl: FormControl = new FormControl('');
    auditDateMaxDate : Date; 
    auditDateMinDate : Date; 
    auditLog : WorkRequestAuditView[] = [];
    auditWR: WorkRequest= {};
   
    systemDate: Date = new Date();

    requestTypes = GlobalConstants.requestTypes;

    currentUser: AzureUser;
    
    progressStatusLevel = 0;
    projectStatuses = GlobalConstants.projectStatuses;

    isInIframe: boolean = false;
    genPDF: boolean = false;


    //it's better to use onNgInit to initialize data vs doing it in the constructor.
    constructor(
        public datePipe: DatePipe,
        private utcConverterService: UtcConverterService,
        private route: ActivatedRoute,
        private router: Router,
        protected override workRequestService: WorkRequestService,
        private location: Location,
        private globalService: GlobalService,
        private viewportScroller: ViewportScroller,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
    ) {
        super(workRequestService);
        //this.screenMode = GlobalConstants.REQUEST_FORM_MODE_USER;
        this.href = this.router.url;
        this.route.paramMap.subscribe((params) => {
            const id = params.get("id");
            const pdf = params.get("pdf");
            if (id) {
                this.getWorkRequest(+id);
                if (pdf) {
                    this.genPDF = true;
                } else {
                    this.getAuditLog(+id);
                }
            } 
        });
      
    }

    //--------------------------
    // Life Cycle Events
    //--------------------------
    ngOnInit(): void {
        this.systemDate = this.globalService.getSystemDate();
        this.currentUser = getCurrentUserFromStorage();
        this.viewportScroller.scrollToPosition([0, 0]);

        if (BrowserUtils.isInIframe()) {
            this.isInIframe = true;
        }

        //When intialized the control is blank, when cleared it is null
        // So we only care about null as this will fire before getting the data.
        //this.auditDateCtrl.valueChanges.subscribe(value => {
        //    if (value === null && this.retrievedWorkRequest) {
        //        alert('clear');
        //        this.workRequest = this.retrievedWorkRequest;
        //    }
        //  });       
        
    }


    ngOnChanges(changes: SimpleChanges) {
        //This is for passing values to the control.  
        if (changes['inputWorkRequest'].currentValue) {
            this.workRequest = this.inputWorkRequest;
            this.retrievedWorkRequest = this.inputWorkRequest;
            this.consolidateData(this.workRequest);
            this.getAuditLog(this.workRequest.workRequestId!);
        }
    }
 
    getWorkRequest(id: number) {
        //We coud hard code this to project.
        this.screenMode = getScreenModeFromStorage();

        if (!this.screenMode) {
            this.determineScreenMode(id).then(() => {
                this.retrieveWorkRequest(id);
            });
        } else {
            this.retrieveWorkRequest(id);
        }
    }
    /**
    * 
    * @param id 
    */
    retrieveWorkRequest(id: number) {

        this.spinner.show();
        this.workRequestService
            .getWorkRequest(id, this.screenMode)
            .subscribe({
                next: (response: WorkRequest) => {
                    this.workRequest = response;
                    if (response === null) {
                        this.alertService.error(
                            this.msg.entryNotFound,
                            this.errorMesageOptions
                        );
                        this.spinner.hide();
                        this.router.navigate(["/home"]);

                    }

                    /*
                    add in audit retreiv
                    */
                    this.retrievedWorkRequest = this.workRequest;
                    this.consolidateData(this.workRequest);

                    setTimeout(() => {
                        if (this.genPDF) {
                            this.generatePDF();
                        }
                    }, 1000);

                    this.spinner.hide();
                }, error: (err: any) => {
                    this.alertService.error(
                        this.msg.entryNotFound,
                        this.errorMesageOptions
                    );
                    this.spinner.hide();
                    this.router.navigate(["/home"]);
                }
            });
    }
    consolidateData(wr : WorkRequest) {
        if (wr.pmMilestones) {
            wr.pmMilestones.sort((a,b) => (new Date(a.date!).getTime()) - (new Date(b.date!).getTime()));
        }
        this.projectManager = "";
        let pms = [];
        if (wr.requestResources) {
            for (const pr of wr.requestResources) {
                if (pr.role === GlobalConstants.PROJECT_MANAGER_ROLE) {
                    pms.push(pr.name);
                }

            }
        }
        this.projectManager = pms.join(" | ");

        this.projectHeader = wr.projectTitle ? wr.projectTitle : wr.wrNumber || '';
    }

    //#region AuditLog Functions
    goBackDay() {

        let newDate: Date;
        // need deepcopy as we don't want to change control yet.
        if (!this.auditDateCtrl.value) {
            newDate = this.auditDateMaxDate;
        } else {
            newDate = new Date(this.auditDateCtrl.value.getTime());
            newDate.setDate(newDate.getDate() - 1);
        }
        if (newDate < this.auditDateMinDate) {
            return;
        }
        this.auditDateCtrl.setValue(newDate);
        this.dateSelectionChange();
    }

    goForwardDay() {
        let newDate = new Date(this.auditDateCtrl.value.getTime());  
        newDate.setDate(newDate.getDate() + 1);
        if (newDate > this.auditDateMaxDate) { 
            return;
        }
        this.auditDateCtrl.setValue(newDate);
        this. dateSelectionChange();
    }

    //The properties in the newValues have capitilized values. .net/javascript issue.
    // So we need to deal with that.
    dateSelectionChange() {
        console.log(this.workRequest);
        let auditDate = this.auditDateCtrl.value;

        if (auditDate === null) {
            this.workRequest = this.retrievedWorkRequest;
            this.consolidateData(this.workRequest);
            return;
        }
        let wr: WorkRequest = { wrNumber : this.workRequest.wrNumber, workRequestId : this.workRequest.workRequestId};
        let pmMilestones : Milestone[] = [];
        let projectResources : Resource[] = [];


        for (let logEntry of this.auditLog) {
            if (logEntry.eventDateUTC && logEntry.tableName === 'WorkRequest') {
                //this get the date at begging of day
                const eventDt = this.convertLogDate(logEntry.eventDateUTC);
                if (eventDt <= this.auditDateCtrl.value) {

                    //});
                    const json =  this.lowerCaseFirstCharOfPproperties(JSON.parse(logEntry.newValues!));
                    this.updateObjectWithChanges(wr,json );             
                    //this.auditWR = { ...this.auditWR, ...json }
                    //Object.assign(wr, json);
                }
            }
            if (logEntry.eventDateUTC && logEntry.tableName === 'WorkRequestMilestone') {
                const json =  this.lowerCaseFirstCharOfPproperties(JSON.parse(logEntry.newValues!));
                const eventDt = this.convertLogDate(logEntry.eventDateUTC);
                if (eventDt <= this.auditDateCtrl.value) {
                    if (logEntry.eventType === "A") {
                        if (json['type'] === "PM") {
                            let milestone: Milestone = { workRequestMilestoneId: logEntry.keyValue };
                            this.updateObjectWithChanges(milestone, json);
                            pmMilestones.push(milestone);
                        }
                        // the type will not be on any change records.
                    } else if (logEntry.eventType === "M") {
                        let milestone: Milestone = pmMilestones.find(m => m.workRequestMilestoneId === logEntry.keyValue) ?? {}
                        if (milestone) {
                            this.updateObjectWithChanges(milestone, json);
                        }

                    } else if (logEntry.eventType === "D") {
                        let index = pmMilestones.findIndex(m => m.workRequestMilestoneId === logEntry.keyValue) ?? {}
                        if (index != -1) {
                            pmMilestones.splice(index, 1);
                        }
                    }
                }
                // console.log(json)
            }
            if (logEntry.eventDateUTC && logEntry.tableName === 'WorkRequestResource') {
                const json  = this.lowerCaseFirstCharOfPproperties(JSON.parse(logEntry.newValues!));
                const eventDt = this.convertLogDate(logEntry.eventDateUTC);
                if (eventDt <= this.auditDateCtrl.value) {
                    if (logEntry.eventType === "A") {
                        if (json['type'] === "Request") {
                            let resource: Resource= { resourceId: logEntry.keyValue };

                            this.updateObjectWithChanges( resource, json);
                            projectResources.push(resource);
                        }
                    } else if (logEntry.eventType === "M") {
                        let resource: Resource = projectResources.find(m => m.resourceId === logEntry.keyValue) ?? {}
                        if (resource) {
                            this.updateObjectWithChanges( resource, json);

                        }


                    } else if (logEntry.eventType === "D") {
                        let index = projectResources.findIndex(m => m.resourceId === logEntry.keyValue) ?? {}
                        if (index != -1) {
                            projectResources.splice(index, 1);
                        }
                    }
                }
            }
        }
       wr.pmMilestones = pmMilestones;
       wr.requestResources = projectResources;
       this.consolidateData(wr);
       this.workRequest = wr;

    }

    /**
     * Convert UTC DateString to LocalDate and remove time.
     * @param dt 
     * @returns 
     */
    convertLogDate(dt: string) : Date { 
        const eventDt = new Date(this.utcConverterService.convertUtcToLocalTime(dt, UtcToLocalTimeFormat.SHORT));
        eventDt.setHours(0, 0, 0, 0);
        return eventDt
    }
    lowerCaseFirstCharOfPproperties(json: { [index: string]: any }) {
        if (json) {
            Object.keys(json).forEach(key => {
                json[`${key.charAt(0).toLowerCase()}${key.slice(1)}`] = json[key];
                delete json[key];

            });
        }
        return json;
    }

    updateObjectWithChanges(obj: {[index: string]: any}, changes: {[index: string]: any}) {
        console.log("Befoee: " , obj)
        Object.keys(changes).forEach(key => {
            obj[`${key.charAt(0).toLowerCase()}${key.slice(1)}`] = changes[key];
        }); 
        console.log("After:" , obj)   
        return obj;   
    }
    getAuditLog(id: number) {
        this.auditDateMaxDate = new Date('1907-01-01');
        this.auditDateMinDate = new Date();
        this.workRequestService
            .getWorkRequestAuditLog(id)
            .subscribe({
                next: (response: WorkRequestAuditView[]) => {
                   
                    if (response === null) {
                        this.alertService.error(
                            this.msg.auditLogRetrievalError,
                            this.errorMesageOptions
                        );
                        this.spinner.hide();
                        //this.router.navigate(["/home"]);

                    }
                    this.auditLog = response;
                    for (let logEntry of this.auditLog) {
                        const eventDt = this.convertLogDate(logEntry.eventDateUTC!);
                        if (eventDt < this.auditDateMinDate) {
                            //console.log(logEntry.newValues);
                            this.auditDateMinDate = eventDt;
                        }
                        if (eventDt > this.auditDateMaxDate) {
                            //console.log(logEntry.newValues);
                            this.auditDateMaxDate = eventDt;
                        }
                        
                    }
                    console.log("Audit log entries: " + this.auditLog.length);
                   
                    
                }, error: (err: any) => {
                    this.alertService.error(
                        this.msg.auditLogRetrievalError,
                        this.errorMesageOptions
                    );
                    this.spinner.hide();
                    //this.router.navigate(["/home"]);
                }
            });
        //this.auditDateMinDate.setDate(this.auditDateMaxDate.getDate() - 7);
    }

    //#endregion

    //#region utility Functions

    decodeStatus(input: string, shortInd: boolean) : string {
        let ret = input;
        for (const s of this.projectStatuses) {
            if (s.key == input) {
                ret = shortInd ? s.short : s.value;
                break;
            }
        }
        return ret;
    }

    generatePDF() {
        const statusReport = document.getElementById('statusReport');

        let reportName = this.workRequest.wrNumber + "_" + this.workRequest.projectTitle;
        const width = statusReport?.scrollWidth ?? 1400;
        const doc = new jsPDF({
            orientation: "landscape",
            unit: "pt",
            format: [statusReport?.scrollHeight ?? 2000, width]
        });

        if (this.auditDateCtrl.value) {
            reportName += "_" + this.globalService.getFileTimestamp(this.auditDateCtrl.value);
        } else {
            reportName += "_" + this.globalService.getFileTimestamp();
        }
        doc.html(statusReport!,
            {
                callback: (doc: any) => {
                    doc.save(reportName + '.pdf');
                }
            });
    }

  
    setProgressLevel() {
        this.progressStatusLevel = 0;
        if (this.workRequest.status == GlobalConstants.STATUS_DRAFT) {
            this.progressStatusLevel = 1;
        } else if (this.workRequest.status == GlobalConstants.STATUS_SUBMITTED) {
            this.progressStatusLevel = 2;
        } else if (this.workRequest.status == GlobalConstants.STATUS_INTERNAL_REVIEW) {
                this.progressStatusLevel = 3;
        } else if (this.workRequest.status == GlobalConstants.STATUS_IN_PROGRESS) {
            this.progressStatusLevel = 4;
        } else if (this.workRequest.status == GlobalConstants.STATUS_CLOSED) {
            this.progressStatusLevel = 5;
        }
    }


  
    getResources() {
        let resources = [];
        if (this.workRequest.requestResources) {
            for (let res of this.workRequest.requestResources) {
                //with malformed names, we could get double spaces, so remove any.
                resources.push((res.name + " (" + res.role + ")").replace(/\s+/g, ' '));
            }
        }
        return resources.join(' | ');
        //return resources.join(' | ') + "<br><br>Last Updated: " + formatDate(this.workRequest.lastModifiedDateUTC!,"MMM dd, yyyy",'en-US') + " (" + this.workRequest.lastModifiedUser + ")";
    }
  
    /*
    doViewNavigation() {
        this.spinner.hide();
        if (getPreviousViewFromStorage() !== "") {
            this.router.navigate([getPreviousViewFromStorage()]);
        } else {
            if (this.screenMode === GlobalConstants.REQUEST_FORM_MODE_USER) {
                this.router.navigate(["/my-work-requests"]);
            } else {
                this.router.navigate(["/work-requests"]);
            }
        }
    }
        */

    scrollTo(target : string) {
        //this.scroller.scrollToAnchor("targetGreen");
        document.getElementById(target)?.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }

    /**
     *
     * @param msg
     */
    handleError(msg: string) {
        this.spinner.hide();
        this.viewportScroller.scrollToPosition([0, 0]);        
        this.alertService.error(msg);
    }

    goBack() {

        if (this.inputWorkRequest) {
            this.closingCompoment.emit(true);
        } else {
            this.location.back();
        }
    }
    //#endregion
  
}
